import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { cs, enUS } from 'date-fns/locale';
import Card from '../common/Card/Card';
import IconText from '../common/IconText/IconText';
import ChevronLink from '../common/ChevronLink/ChevronLink';
import { SessionsDataResponseType } from '../../types';

export const MeetingCard = ({ meetingData }: { meetingData: SessionsDataResponseType }) => {
    const { municipalitaId, bodyType, zastupitelstvoId } = useParams();
    const { t, i18n } = useTranslation(['translation', 'meetings']);
    const currentLocale = i18n.language;
    const formattedDate = format(new Date(meetingData.datum.split('.').reverse().join('-')), 'd. MMMM yyyy', {
        locale: currentLocale === 'cs' ? cs : enUS
    });

    const percentageAttendanceString = `${meetingData.dochazka.toFixed(2)}%`;
    const mutedAttendenceString = `(${t('x-out-of-y', {
        x: meetingData.ucast,
        y: meetingData.celkem
    })})`;

    return (
        <Card
            key={meetingData.id}
            className='card-list-item'
            link={`/${municipalitaId}/${bodyType}/${zastupitelstvoId}/zasedani/${meetingData.id}`}
        >
            <h4>
                {t('meeting-no')} {meetingData.cislo_zasedani}
            </h4>
            <div className='card-list-item-content'>
                <IconText icon='calendar_today' text={formattedDate} highlightSubString={formattedDate} />
                <IconText
                    icon='group'
                    text={`${percentageAttendanceString}${mutedAttendenceString}  ${t('attendanceOfMembers')}`}
                    highlightSubString={percentageAttendanceString}
                    mutedSubString={mutedAttendenceString}
                />
                <div className='link-container'>
                    <IconText
                        icon='select_check_box'
                        text={`${meetingData.pocet_platnych_hlasovani} ${t('Votings').toLowerCase()}`}
                        highlightSubString={`${meetingData.pocet_platnych_hlasovani}`}
                    />
                    <ChevronLink text={t('details')} chevronDirection='right' linkDisabled />
                </div>
            </div>
        </Card>
    );
};
